import httpClient from "./httpClient";

class SubscriberApi {
    create = async (payload) => {
        return await httpClient.post('/cheap-study/v1/subscribers/', payload);
    }
}

export const subscriberApi = new SubscriberApi();